import { ReportDashboardQueryFilterComponent } from './../report-dashboard/query-request/query-filter/report-dashboard-query-filter.component';
import { SimulationComponent } from './../simulation/simulation.component';
import { ReportDashboardPermissionComponent } from './../report-dashboard/permission/report-dashboard-permission.component';
import { SyntheticColumnBuilderComponent } from './../report-dashboard/synthetic-column/synthetic-column-builder.component';
import { ChooserBarComponent } from './../common/chooser-bar/chooser-bar.component';
import { ALMTraderComponent } from './alm-trader/alm-trader.component';
import { DashboardModule } from './../dashboard/dashboard.module';
import { NgModule } from '@angular/core';
import { ALMManagerComponent } from './alm-manager/alm-manager.component';
import { CommonModule } from '@angular/common';
import { UIModule } from '../common/ui.module';
import { ALMBreakDownLadderTableComponent } from './alm-trader/alm-break-down-ladder-table.component';
import { ALMAttributeLadderTableComponent } from './alm-trader/alm-attribute-ladder-table.component';
import { TopNTableComponent } from './alm-trader/top-n-table.component';
import { ALMHistoricalChartComponent } from './common/alm-historical-chart.component';
import { ReportDashboardComponent, ReportDashboardPreviewInnerComponent } from '../report-dashboard/report-dashboard.component';
import { ReportDashboardConfigComponent } from '../report-dashboard/report-dashboard-config.component';
import { ReportDashboardQueryRequestComponent } from '../report-dashboard/query-request/report-dashboard-query-request.component';
import { TreeDragDropService } from 'primeng/api';
import { AceEditorModule } from 'ng2-ace-editor';
import { ALMAdhocComponent } from './alm-adhoc/alm-adhoc.component';
import { DashboardLayoutBuilderComponent } from '../report-dashboard/dashboard-layout/dashboard-layout-builder.component';
import { ReportDashboardPublishComponent } from '../report-dashboard/publish/report-dashboard-publish.component';
import { ReportDashboardColumnChooserDialogComponent } from '../report-dashboard/query-request/report-dashboard-column-chooser-dialog.component';
@NgModule({
    imports: [
        CommonModule,
        UIModule,
        DashboardModule,
        AceEditorModule,
    ],
    declarations: [
        TopNTableComponent,
        ALMBreakDownLadderTableComponent,
        ALMAttributeLadderTableComponent,
        ALMManagerComponent,
        ALMTraderComponent,
        ALMHistoricalChartComponent,
        DashboardLayoutBuilderComponent,
        ReportDashboardConfigComponent,
        SyntheticColumnBuilderComponent,
        ReportDashboardPreviewInnerComponent,
        ReportDashboardPermissionComponent,
        ReportDashboardPublishComponent,
        ReportDashboardQueryFilterComponent,
        ReportDashboardComponent,
        ReportDashboardQueryRequestComponent,
        ChooserBarComponent,
        ReportDashboardColumnChooserDialogComponent,
        ALMAdhocComponent,
        SimulationComponent,
    ],
    exports: [
        TopNTableComponent,
        ALMBreakDownLadderTableComponent,
        ALMAttributeLadderTableComponent,
        ALMManagerComponent,
        ALMTraderComponent,
        ALMHistoricalChartComponent,
        ChooserBarComponent,
        ReportDashboardPermissionComponent,
        ReportDashboardComponent,
    ],
    providers: [
        TreeDragDropService,
    ]
})
export class ALMModule {

}
